<template>
  <div class="page-stack">
    <section class="surface-card test-send-card">
      <div class="section-head">
        <div>
          <p class="eyebrow">UAT CONTROLLED SEND</p>
          <h3>UAT 白名单测试发送</h3>
          <p>仅允许后端 Apollo 配置的号码；供应商与模板由网关固定选择，策略可在下方选择。</p>
        </div>
      </div>

      <el-alert
        v-if="!available"
        title="当前环境未开放测试发送"
        type="warning"
        :closable="false"
        show-icon
      />

      <el-form ref="form" :model="form" :rules="rules" label-position="top" :disabled="!available || sending">
        <el-form-item label="白名单手机号（E.164）" prop="receiverPhone">
          <el-input v-model.trim="form.receiverPhone" maxlength="32" placeholder="+234..." />
        </el-form-item>
        <el-form-item label="外呼策略" prop="strategyCode">
          <el-select v-model="form.strategyCode" style="width:100%">
            <el-option label="D-1（默认策略）" value="D-1" />
            <el-option label="S0（语音策略 S0）" value="S0" />
            <el-option label="S1（语音策略 S1）" value="S1" />
          </el-select>
        </el-form-item>
        <div class="form-grid">
          <el-form-item label="客户称呼" prop="variables.customer_name">
            <el-input v-model.trim="form.variables.customer_name" maxlength="128" />
          </el-form-item>
          <el-form-item label="性别" prop="variables.gender">
            <el-select v-model="form.variables.gender">
              <el-option label="Female" value="female" />
              <el-option label="Male" value="male" />
            </el-select>
          </el-form-item>
          <el-form-item label="应还金额" prop="variables.due_amount">
            <el-input v-model.trim="form.variables.due_amount" />
          </el-form-item>
          <el-form-item label="应还日期" prop="variables.due_date">
            <el-date-picker v-model="form.variables.due_date" type="date" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="借款金额" prop="variables.loan_amount">
            <el-input v-model.trim="form.variables.loan_amount" />
          </el-form-item>
          <el-form-item label="借款日期" prop="variables.loan_date">
            <el-date-picker v-model="form.variables.loan_date" type="date" value-format="yyyy-MM-dd" />
          </el-form-item>
          <el-form-item label="产品名称" prop="variables.product_name">
            <el-input v-model.trim="form.variables.product_name" maxlength="128" />
          </el-form-item>
          <el-form-item label="期数" prop="variables.term">
            <el-input-number v-model="form.variables.term" :min="1" :max="999" />
          </el-form-item>
        </div>
        <el-form-item prop="confirmed">
          <el-checkbox v-model="form.confirmed">我确认这是 UAT 白名单号码并同意发起真实外呼测试</el-checkbox>
        </el-form-item>
        <el-button type="primary" :loading="sending" @click="submit">确认并发送</el-button>
      </el-form>
    </section>

    <section v-if="result" class="surface-card result-card">
      <p class="eyebrow">SUBMITTED</p>
      <h3>{{ result.message.messageId }}</h3>
      <p>业务 ID：{{ result.message.bizId }}</p>
      <p>当前状态：<status-tag :status="result.message.status" /></p>
      <el-button type="text" @click="$router.push(`/messages/${result.message.messageId}`)">查看发送详情</el-button>
    </section>
  </div>
</template>

<script>
import { getAdminCapabilities, submitUatTestSend } from '../api/admin'
import StatusTag from '../components/StatusTag.vue'

export default {
  name: 'UatTestSendView',
  components: { StatusTag },
  data () {
    return {
      available: false,
      sending: false,
      result: null,
      form: {
        receiverPhone: '',
        strategyCode: 'D-1',
        confirmed: false,
        variables: {
          customer_name: 'UAT User',
          gender: 'female',
          due_amount: '3500.50',
          due_date: '',
          loan_amount: '5000.00',
          loan_date: '',
          product_name: 'UAT Product',
          term: 1
        }
      },
      rules: {
        receiverPhone: [{ required: true, message: '请输入 E.164 白名单号码', trigger: 'blur' }],
        strategyCode: [{ required: true, message: '请选择外呼策略', trigger: 'change' }],
        confirmed: [{
          validator: (rule, value, callback) => value ? callback() : callback(new Error('请先确认 UAT 发送')),
          trigger: 'change'
        }]
      }
    }
  },
  async created () {
    try {
      const capabilities = await getAdminCapabilities()
      this.available = Boolean(capabilities.uatTestSendEnabled)
    } catch (error) {
      this.available = false
    }
  },
  methods: {
    async submit () {
      const valid = await this.$refs.form.validate().catch(() => false)
      if (!valid) return
      const confirmed = await this.$confirm('将向白名单号码发起真实 UAT 外呼，是否继续？', '最终确认', {
        confirmButtonText: '确认发送',
        cancelButtonText: '取消',
        type: 'warning'
      }).catch(() => false)
      if (!confirmed) return
      this.sending = true
      try {
        this.result = await submitUatTestSend(this.form)
        this.$message.success('UAT 测试任务已提交')
      } catch (error) {
        this.$message.error((error.response && error.response.data && error.response.data.message) || '测试发送失败')
      } finally {
        this.sending = false
      }
    }
  }
}
</script>

<style scoped>
.test-send-card { max-width: 920px; }
.test-send-card .el-form { margin-top: 24px; }
.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 1fr)); gap: 0 20px; }
.result-card { max-width: 920px; border-left: 4px solid var(--teal); }
@media (max-width: 760px) {
  .form-grid { grid-template-columns: 1fr; }
}
</style>
